module.exports = __webpack_public_path__ + "img/danzhan.cac77436.jpg";